import loder from 'loder';
import EnvUtils from '@src/utils/env-utils';

export default async function inject(scriptModels) {
  const availableKeys = Object.keys(scriptModels).filter(key => {
    const scriptModel = scriptModels[key];
    const { condition, env } = scriptModel;
    return condition && isMatchCurrentEnv(env);
  });
  const promises = availableKeys.map(key => {
    const scriptModel = scriptModels[key];
    const { script, resolve, reject, prepare, custom } = scriptModel;
    prepare();
    if (custom) {
      return custom(loder);
    } else {
      let promise;
      if (Object.prototype.toString.call(script) === '[object Array]') {
        promise = (async () => {
          for (let i = 0; i < script.length; i++) {
            const scriptSrc = script[i];
            await loder.loadScript(scriptSrc);
          }
        })();
      } else {
        promise = loder.loadScript(script);
      }
      loder.add(key, promise.then(resolve, reject));
      return promise;
    }
  });
  return Promise.all(promises);
}

function isMatchCurrentEnv(env) {
  const currentEnv = EnvUtils.getEnv();
  return env === undefined || env === currentEnv || (Array.isArray(env) && ~env.indexOf(currentEnv));
}
